import { localStorageKey } from 'hooks/useLocalStorageState'

type Announcement = {
  id: string
  textKey: string
  show: boolean
  longDescriptionKey?: string
  linkPath?: string
  external?: boolean
}

type SwapAnnouncement = {
  id: string
  titleKey: string
  descriptionKey: string
  show: boolean
  longDescriptionKey?: string
  linkPath?: string
  imagePath?: string
  external?: boolean
}

export const ANNOUNCEMENT_ID_KEY = localStorageKey('announcement-id-0.5', '')
export const SWAP_ANNOUNCEMENT_ID_KEY = localStorageKey(
  'swap-announcement-id-0.1',
  '',
)

export const ANNOUNCEMENT = {
  id: '7',
  textKey: 'announcement.text',
  show: true,
  linkPath: 'https://ride.markets',
  external: true,
  longDescriptionKey: undefined,
} as const satisfies Announcement

export const SWAP_ANNOUNCEMENT = {
  id: '3',
  titleKey: 'swap.title',
  descriptionKey: 'swap.description',
  show: true,
  longDescriptionKey: 'swap.longDescription',
  linkPath: 'https://ride.markets',
  external: true,
  imagePath: undefined,
} as const satisfies SwapAnnouncement
